import { StatusChipVariant } from './status-chip.types';
import styles from './status-chip.module.scss';
import Icon from '@ant-design/icons';
import { chipIcon, statusChipText } from './status-chip.constants';
import clsx from 'clsx';

interface StatusChipProps {
  variant?: StatusChipVariant;
  className?: string;
}

export default function StatusChip({ variant = 'info', className }: StatusChipProps) {
  return (
    <div
      className={clsx(
        className,
        styles.statusChipContainer,
        styles[`statusChipContainer-${variant}`]
      )}
    >
      <span className={styles[`statusChip-${variant}`]}>
        <Icon component={chipIcon[variant]} />
      </span>
      <span className={`${styles[`statusChip-${variant}`]} ${styles.statusChipText}`}>
        {statusChipText[variant]}
      </span>
    </div>
  );
}
